export function timeoutPromise (delay, callback) {
  return new Promise(function (resolve, reject) {
    callback(resolve, reject);
    const timeout = setTimeout(function () {
      clearTimeout(timeout);
      reject('Promise timed out after ' + delay + ' ms.');
    }, delay);
  });
}

export function waitUntil (delay, callback) {
  return timeoutPromise(delay, (resolve) => {
    function wait () {
      const value = callback();
      if (value) {
        resolve(value);
      } else {
        const timeout = setTimeout(() => {
          clearTimeout(timeout);
          wait();
        }, 100);
      }
    }

    wait();
  });
}
